/* eslint-disable */
<template>
  <div class="container-fluid mtb15 no-fluid">    
    <div class="row sm-gutters">
      <!-- Menu -->
      <div v-if="1200 < getWindowsWidth" class="col-sm-12 col-md-2">
        <AppMenu></AppMenu>
      </div>
      <!-- Stocks and watchlists dashboard -->
      <!-- Modal confirm delete -->
      <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirmDeleteLabel" aria-hidden="true"
        :class="{ 'show': watchlistSelectionModalShow, 'd-block': watchlistSelectionModalActive }">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="confirmDeleteLabel">{{ getConfirmDeleteValueLabel }}</h5>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal" @click="deleteWatchlist()">{{
                getConfirmLabel
                }}</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal"
                @click="watchlistSelectionModalActive = false; watchlistSelectionModalShow = false;">{{
                getCloseLabel
                }}</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="watchlistSelectionModalActive" class="modal-backdrop fade show"></div>
      <!-- Modal trade confirmed -->
      <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="tradeConfirmedLabel" aria-hidden="true"
        :class="{ 'show': tradeConfirmedModalShow, 'd-block': tradeConfirmedModalActive }">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header trade-confirmed-modal-header">
              <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"
                @click="tradeConfirmedModalActive = false; tradeConfirmedModalShow = false;"></button>
            </div>
            <div class="modal-body">
                <TradeConfirmed :order="orderModel" />
            </div>
          </div>
        </div>
      </div>
      <!-- Modal show trading in responsive -->
      <div  v-if="1200 > getWindowsWidth" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="showTradingInResponsive" aria-hidden="true"
        :class="{ 'show': tradingInResponsiveModalShow, 'd-block': tradingInResponsiveModalActive }">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" 
                    @click="tradingInResponsiveModalShow = false; tradingInResponsiveModalActive = false; showTradingInResponsive = false;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <Trading :key="this.selectedItemCode"></Trading>
            </div>
          </div>
        </div>
      </div>      
      <div class="col-sm-12" :class="{'col-md-10' : 1200 < getWindowsWidth }">
        <div class="row">
          <!-- watchlists -->
          <div v-if="!showTradingInResponsive" id="watchlists-column" class="col-sm-12 h-100" :class="{ 'col-md-8': 1200 < getWindowsWidth && 0 === activeTop10Item.localeCompare('INDEX') }">           
            <div class="row">
              <div class="input-group w-100">
                <ul class="nav nav-tabs nav-pills text-nowrap watchlist-tabs" style="overflow-x: auto; max-width: 100%; max-height: auto; flex: 1; flex-wrap: nowrap;"
                  :key="getUserWatchLists.length">
                  <template v-if="0 === activeTop10Item.localeCompare('INDEX')">
                    <li v-for="(watchlist) in getUserWatchLists" :key="watchlist.wln"
                      class="nav-item d-flex justify-content-between align-items-center" role="presentation">
                      <div class="d-flex">
                        <div>
                          <button v-if="watchlist.wln.toString().toUpperCase() !== 'DEFAULT'" class="nav-link"
                            :class="{ 'active': 0 === watchlist.wln.toString().toUpperCase().localeCompare(activeUserWatchlist.toUpperCase()), 'xsmall-font-size': 1200 > getWindowsWidth }"
                            :id="watchlist.wln + '-id'" type="button" @click.prevent="userWatchlistNameClick(watchlist)">
                            {{ watchlist.wln.toString().toUpperCase() }}
                          </button>
                          <button v-else class="nav-link"
                            :class="{ 'active': 0 === watchlist.wln.toString().toUpperCase().localeCompare(activeUserWatchlist.toUpperCase()), 'xsmall-font-size': 1200 > getWindowsWidth }"
                            :id="watchlist.wln + '-id'" type="button" @click.prevent="userWatchlistNameClick(watchlist)">
                            {{ getWatchlistLabel.toUpperCase() }}
                          </button>
                        </div>
                      </div>
                      <div>
                        <div v-if="canDeleteWatchlist(watchlist.wln)" class="text-end">
                          <button type="button" class="btn-close"
                            @click.prevent="setWatchlistToDelete(watchlist.wln)"></button>
                        </div>
                      </div>
                    </li>
                  </template>
                  <template v-if="0 === activeTop10Item.localeCompare('INDEX')">
                    <li v-for="(watchlist) in getIndexedWatchlists" :key="watchlist.wln"
                      class="nav-item d-flex justify-content-between align-items-center" role="presentation">
                      <div class="d-flex">
                        <div>
                          <button class="nav-link"
                            :class="{ 'active': 0 === watchlist.wln.toString().toUpperCase().localeCompare(activeIndexWatchlist.toUpperCase()), 'xsmall-font-size': 1200 > getWindowsWidth }"
                            :id="watchlist.wln + '-id'" type="button" @click.prevent="indexWatchlistNameClick(watchlist);">
                            {{ watchlist.wln.toString().toUpperCase() }}
                          </button>
                        </div>
                      </div>
                    </li>
                  </template>
                  <template v-else>
                    <li v-for="selection in topTenSelections" :key="selection.value"
                      class="nav-item d-flex align-items-center" role="presentation">
                      <button class="nav-link"
                        :class="{ 'active': 0 === selection.value.localeCompare(activeTop10Item), 'xsmall-font-size': 1200 > getWindowsWidth }"
                        type="button" @click.prevent="top10ItemClick(selection.value)">
                        {{ selection.label.toUpperCase() }}
                      </button>
                    </li>
                  </template>
                </ul>
                <div class="input-group-append">
                  <!-- sorting -->
                  <a class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    <img width="15" src="@/assets/images/sort.svg" alt="" />
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end watchlist-sort-menu">
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="activeSortingOption = 0;">
                        {{ capitalizeFirstLetter(getSortDefaultLabel) }}
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="activeSortingOption = 1;">
                        {{ capitalizeFirstLetter(getSortSymbolAscLabel) }}
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="activeSortingOption = 2;">
                        {{ capitalizeFirstLetter(getSortSymbolDescLabel) }}
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="activeSortingOption = 3;">
                        {{ capitalizeFirstLetter(getSortNameAscLabel) }}
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="activeSortingOption = 4;">
                        {{ capitalizeFirstLetter(getSortNameDescLabel) }}
                      </a>
                    </li>
                  </ul>
                  <!-- selections -->
                  <a class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    <img width="15" src="@/assets/images/filter.svg" alt="" />
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end watchlist-selection-menu">
                    <li><a class="dropdown-item" href="#" @click.prevent="top10ItemClick('INDEX')">{{ capitalizeFirstLetter(getSortDefaultLabel) }}</a></li>
                    <li><a class="dropdown-item" href="#" @click.prevent="top10ItemClick('GAINERS')">{{ capitalizeFirstLetter(getGainersLabel) }}</a></li>
                    <li><a class="dropdown-item" href="#" @click.prevent="top10ItemClick('LOSERS')">{{ capitalizeFirstLetter(getLosersLabel) }}</a></li>
                    <li><a class="dropdown-item" href="#" @click.prevent="top10ItemClick('MOST TRADED')">{{ capitalizeFirstLetter(getMostTradedLabel) }}</a></li>
                    <li><a class="dropdown-item" href="#" @click.prevent="top10ItemClick('INDEXES')">{{ capitalizeFirstLetter(getIndexesLabel) }}</a></li>
                  </ul>
                </div>
              </div>
            </div>            
            <div v-if="topTenLoading || indexWatchlistLoading" class="top-ten-loading" :class="{ 'index-watchlist-loading': indexWatchlistLoading }">
              <Preloader />
            </div>
            <!-- gainers -->
            <div v-else-if="0 === activeTop10Item.localeCompare('GAINERS')" class="table-responsive">
              <Top10ListItem key="gainers-list" :items="getGainers" />
            </div>
            <!-- losers -->
            <div v-else-if="0 === activeTop10Item.localeCompare('LOSERS')" class="table-responsive">
              <Top10ListItem key="losers-list" :items="getLosers" />
            </div>
            <!-- most traded -->
            <div v-else-if="0 === activeTop10Item.localeCompare('MOST TRADED')" class="table-responsive">
              <Top10ListItem key="most-traded-list" :items="getMostTraded" />
            </div>            
            <!-- indexes -->
            <div v-else-if="0 === activeTop10Item.localeCompare('INDEXES')" class="table-responsive indexes-watchlist-table">
              <table class="table w-100 indexes-table">
                <colgroup>
                  <col class="index-column-width" />
                  <col class="index-data-column-width" />
                  <col class="index-data-column-width" />
                  <col class="index-data-column-width" />
                </colgroup>
                <thead>
                  <tr>
                    <th class="name-column" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getIndexLabel.toUpperCase() }}</th>
                    <th class="data-column" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getNetChangeLabel.toUpperCase() }}</th>
                    <th class="data-column" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">%{{ getNetChangeLabel.toUpperCase() }}</th>
                    <th class="data-column" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getValueLabel.toUpperCase() }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="indx in getIndexes" :key="indx.sc">
                      <td>
                        <strong>{{ indx?.sc.toString().toUpperCase() }}</strong>
                      </td>
                      <td v-show="isNaN(parseFloat(indx?.dif))" align="center" colspan="3">
                          <Preloader></Preloader>
                      </td>
                      <td class="stock-data xsmall-font-size align-text-right" :class="getIndexItemColor(indx?.dif)">
                        {{ parseNumber(indx?.dif) }}
                      </td>
                      <td class="stock-data xsmall-font-size align-text-right">
                        <div v-show="isNaN(parseFloat(indx?.ch))">
                            <span :class="getIndexItemColor(indx?.ch)">0%</span>
                        </div>
                        <div v-show="0 < parseFloat(indx?.ch)">
                            <span :class="getIndexItemColor(indx?.ch)">+{{ parseNumber(indx?.ch) }}%</span>
                        </div>
                        <div v-show="0 >= parseFloat(indx?.ch)">
                            <span :class="getIndexItemColor(indx?.ch)">{{ parseNumber(indx?.ch) }}%</span>
                        </div>
                      </td>
                      <td class="stock-data xsmall-font-size align-text-right">
                        {{ parseNumber(indx?.val, 2) }}
                      </td>
                  </tr>                  
                </tbody>
              </table>
            </div>
            <!-- watchlists data -->
            <KeepAlive v-if="0 === activeTop10Item.localeCompare('INDEX') && !indexWatchlistLoading">
              <StockList
                :key="activeIndexWatchlist || activeUserWatchlist || 'watchlist'"
                class="mt-3"
                :userWatchlists="!activeIndexWatchlist"></StockList>
            </KeepAlive>
          </div>          
          <!-- Trading -->
          <div v-if="1200 < getWindowsWidth && 0 === activeTop10Item.localeCompare('INDEX')" id="trading-column" class="col-sm-12 h-100" :class="{ 'col-md-4': 1200 < getWindowsWidth }">
            <Trading :key="this.selectedItemCode"></Trading>
          </div>
        </div>
      </div>
    </div>
    <!-- trade button -->
    <button v-if="1200 > getWindowsWidth && !showTradingInResponsive" id="tradeButton" class="btn position-fixed bottom-0 end-0" 
      @click.prevent="showTradingInResponsive = true; tradingInResponsiveModalShow = true; tradingInResponsiveModalActive = true;">
      <img src="@/assets/images/trade_button.svg" alt="">
    </button>
  </div>
</template>

<script>
import http from "@/api/http-common";
import StockList from './components/StockList.vue';
import Top10ListItem from './components/Top10ListItem.vue';
import AppMenu from '@/components/ui/AppMenu.vue';
import Trading from '@/features/trading/TradingView.vue';
import UiUtils from "@/assets/js/ui_utils.js";
import ApiUtils from "@/assets/js/api_utils.js";
import I18n from "@/lang/i18n.js";
import TradeConfirmed from '@/features/trading/components/TradeConfirmed.vue';
import Preloader from "@/components/ui/Preloader.vue";
import HttpUtils from "@/assets/js/http_utils.js";
import { addSseEventListeners, closeSseClient, createSseClient, parseSseJsonEvent, startSseMonitor, stopSseMonitor } from "@/api/sse-client";

/**
 * this method identifies unique stocks in list with O(n) complexity (fastest possible)
 * taken from https://stackoverflow.com/questions/15125920/how-to-get-distinct-values-from-an-array-of-objects-in-javascript
 */
function onlyUnique(array) {
  const unique = [];
  const distinct = [];
  for (let i = 0; i < array.length; i++) {
    if (!unique[array[i].cMIC + array[i].code]) {
      distinct.push(array[i]);
      unique[array[i].cMIC + array[i].code] = 1;
    }
  }

  return distinct;
}

const DEFAULT_INDEX_WATCHLISTS = [
  { wln: "SOFIX", xc: "XBUL", ord: 0, exchangeIds: [1] },
  { wln: "BGBX40", xc: "XBUL", ord: 1, exchangeIds: [1] },
  { wln: "BGTR30", xc: "XBUL", ord: 2, exchangeIds: [1] },
  { wln: "BGREIT", xc: "XBUL", ord: 3, exchangeIds: [1] },
  { wln: "DAX", xc: "XETR", ord: 4, exchangeIds: [2, 3] },
  { wln: "MDAX", xc: "XETR", ord: 5, exchangeIds: [2, 3] },
  { wln: "SDAX", xc: "XETR", ord: 6, exchangeIds: [2, 3] },
  { wln: "TecDAX", xc: "XETR", ord: 7, exchangeIds: [2, 3] },
];

// https://stackoverflow.com/questions/1129216/sort-array-of-objects-by-string-property-value
function dynamicSort(property) {
  let sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /* next line works with strings and numbers, 
     * and you may want to customize it to your needs
     */
    const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  }
}

export default {
  components: {
    StockList,
    Top10ListItem,
    Trading,
    AppMenu,
    TradeConfirmed,
    Preloader
  },
  data() {
    return {
      selectedItemCode: "",             
      /* active modal dialog for watchlist selection */
      watchlistSelectionModalActive: false,
      /* show modal dialog for watchlist selection */
      watchlistSelectionModalShow: false,
      watchlistNameToDelete: "",
      /* 0 - all exchanges, other: exchange id */
      selectedExchange: this.$store.getters["getSelectedExchangeCode"],
      /* currently selected user watchlist */
      activeUserWatchlist: "",
      /* last selected selected user watchlist */
      lastActiveUserWatchlist: "",
      /* currently selected index watchlist */
      activeIndexWatchlist: "",
      /* last selected selected index watchlist */
      lastActiveIndexWatchlist: "",      
      /* top 10 selected item */
      activeTop10Item: "INDEX",
      tradeConfirmedModalActive: false,
      tradeConfirmedModalShow: false,
      orderModel: {},
      hasReestablishingConnectionMessage: false,
      sseVerifier: null,
      hasEvents: false,
      sseClient: null,
      activeSortingOption: 0,
      showTradingInResponsive: false,
      tradingInResponsiveModalShow: false,
      tradingInResponsiveModalActive: false,
      topTenLoading: false,
      topTenLoadRequestId: 0,
      indexWatchlistLoading: false,
      indexWatchlistLoadRequestId: 0
    }
  },
  watch: {
    getSelectedTradingCode: function (newVal, oldVal) {
      if (oldVal !== newVal) {
        if (this.$store.getters["getSuppressSelectedTradingQuoteSync"]) {
          return;
        }
        (async () => await this.setQuoteTr(newVal))();
      }
    },
    getSelectedExchangeCode: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedExchange = parseInt(newVal);
        // refresh top ten/indexes only when one of those views is visible
        (async () => {
          if (0 === this.activeTop10Item.localeCompare('INDEX')) {
            const availableIndexes = this.getIndexedWatchlists || [];
            const activeIndexIsAvailable = availableIndexes.some(item => {
              return 0 === item.wln.toString().localeCompare(this.activeIndexWatchlist);
            });
            if (this.activeIndexWatchlist && !activeIndexIsAvailable) {
              this.activeIndexWatchlist = "";
              this.lastActiveIndexWatchlist = "";
              this.$store.commit("setSearchedStocksIndexWatchlist", []);
            }
            return;
          }
          if (!this.isTopTenSelection(this.activeTop10Item)) {
            return;
          }
          await this.loadTopTenDataWithPreloader(this.activeTop10Item);
        })();
      }
    },
    activeTop10Item: function(newVal) {
      if (0 !== newVal.localeCompare('INDEX')) {
        this.lastActiveIndexWatchlist = this.activeIndexWatchlist;
        this.activeIndexWatchlist = "";
      } else {
        this.activeIndexWatchlist = this.lastActiveIndexWatchlist;
      }
    },
    activeSortingOption: function(newVal) {
      this.$store.commit("setWatchlistSortingOption", newVal);
    },
    stopSseState: function (newVal) {
      if (newVal) {
        if (this.sseClient) {
          closeSseClient(this.sseClient);
          this.$store.commit("setStopSse", false);
        }
      }
    }    
  },
  methods: {
    t(key, ...args) {
      const language = typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage;
      return I18n.t(key, language, ...args);
    },
    getIndexItemColor(change) {
      if (isNaN(parseFloat(change)) || 0 === parseFloat(change)) {
        return "blackColor";
      }
      if (0 > parseFloat(change)) {
        return "redColor";
      }
      return "greenColor";
    },
    formatPrice(val, curr, autoDigits = null) {
      return UiUtils.formatPrice(val, curr, this.getUserLanguage, autoDigits);
    },
    capitalizeFirstLetter(string) {
      return string
        ? string.charAt(0).toUpperCase() + string.slice(1)
        : "";
    },
    getIndexCurrency(indexName) {
      const exchanges = this.$store.getters["getExchanges"];
      return UiUtils.getIndexCurrencyByName(exchanges, indexName);
    },
    getUserType() {
      return this.$store.getters["getUserType"];
    },
    parseNumber(num, afterDot = 2) {
      return UiUtils.formatNumber(num, afterDot);
    },
    formOrderObject(event) {
      this.orderModel.type = this.getOrderType(event.t);
      this.orderModel.ex = event.xc;
      this.orderModel.code = event.sc;
      this.orderModel.name = 0 === 'BG'.localeCompare(this.getUserLanguage)
        ? event.nBG
        : event.nEN;
      this.orderModel.amount = this.parseNumber(event.qty);
      this.orderModel.price = event.sp;
      this.orderModel.price_total = event.pt;
      this.orderModel.currency = event.cc;
      this.orderModel.stid = event.stid;
      this.orderModel.oid = event.id;
      this.orderModel.fee = event.fee;
      this.orderModel.time = this.getDate(event.d);
      this.orderModel.total_amount = Number(event.pt || 0) + Number(event.fee || 0);
    },    
    setupStream() {
      const user = this.$store.getters["getUser"];
      if (!user) {
        return;
      }
      try {
        this.sseClient = createSseClient(this.getUserType(), user);

        // verify we have valid connection
        if (!this.sseClient) {
          return;
        }
        // show message if connection has been lost
        if (this.hasReestablishingConnectionMessage) {
          const reestablishConnectionMessage = this.getReestablishedConnectionLabel;
          // show user info
          this.$toast.success(reestablishConnectionMessage, {
            "duration": 5000,
            "pauseOnHover": true
          });
          this.$store.commit("addSystemMessage", {
            date: (new Date()).getTime(),
            mess: reestablishConnectionMessage,
            error: false
          });
          this.hasReestablishingConnectionMessage = false;
        }

        addSseEventListeners(this.sseClient, this.dashboardSseHandlers());
      } catch (error) {
        console.error(error);
      }
    },
    dashboardSseHandlers() {
      return {
        HEARTBEAT: () => {
          this.hasEvents = true;
        },
        SESSION_CLOSED: () => {
          this.hasEvents = true;
          ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1);
        },
        QUOTE: event => this.commitSseJson("updateQuote", event, false),
        QUOTE_TR: event => this.commitSseJson("setQuoteTrading", event),
        QUOTE_EX: event => this.commitSseJson("setQuoteExtended", event),
        DEPTH: event => this.commitSseJson("setDepth", event),
        PHASE: event => this.commitSseJson("upsertExchangesPhases", event),
        WALLET: event => this.commitSseJson("wallet/setWallet", event),
        GAINER_LIST: event => this.handleTopTenSseEvent("updateGainersList", event),
        GAINER: event => this.handleTopTenSseEvent("updateGainers", event),
        LOSER_LIST: event => this.handleTopTenSseEvent("updateLosersList", event),
        LOSER: event => this.handleTopTenSseEvent("updateLosers", event),
        MOST_TRADED_LIST: event => this.handleTopTenSseEvent("updateMostTradedList", event),
        MOST_TRADED: event => this.handleTopTenSseEvent("updateMostTraded", event),
        INDEX: event => this.commitSseJson("updateIndex", event),
        EXECUTED: event => this.handleDashboardExecutedSseEvent(event),
        REJECTED: event => this.handleDashboardRejectedSseEvent(event),
        error: event => this.handleDashboardSseError(event)
      };
    },
    commitSseJson(mutation, event, markEvents = true) {
      if (markEvents) {
        this.hasEvents = true;
      }
      try {
        this.$store.commit(mutation, parseSseJsonEvent(event));
      } catch (err) {
        console.error(err);
      }
    },
    handleDashboardExecutedSseEvent(event) {
      this.hasEvents = true;
      try {
        const orderData = parseSseJsonEvent(event);
        this.formOrderObject(orderData);
        this.tradeConfirmedModalShow = true;
        this.tradeConfirmedModalActive = true;
        let mess = "";
        if (0 === "BG".localeCompare(this.getUserLanguage)) {
          mess = "Вашата поръчка №";
        } else {
          mess = "Your order #";
        }
        const stockName = 0 === "BG".localeCompare(this.getUserLanguage)
          ? (orderData.nBG || orderData.nEN)
          : (orderData.nEN || orderData.nBG);
        const resolvedStockName = stockName && "n/a" !== stockName.toString().toLowerCase()
          ? stockName
          : this.getStockName(orderData.sc, orderData.xc || orderData.ex);
        const stockNameLabel = resolvedStockName && "n/a" !== resolvedStockName.toString().toLowerCase()
          ? " (" + resolvedStockName + ")" : "";
        mess = mess + orderData.id + ", " + this.getDate(orderData.d) +
          ", " + this.getOrderType(orderData.t) + " " + orderData.sc + stockNameLabel + " " +
          orderData.qty + " X " + this.formatPrice(orderData.sp, orderData.cc);
        if (0 === "BG".localeCompare(this.getUserLanguage)) {
          mess = mess + " е изпълнена";
        } else {
          mess = mess + " is completed";
        }
        this.$toast.success(mess, {
          "duration": 5000,
          "pauseOnHover": true
        });
        this.$store.commit("addSystemMessage", {
          date: (new Date()).getTime(),
          mess: mess,
          error: false
        });
      } catch (err) {
        console.error(err);
      }
    },
    handleDashboardRejectedSseEvent(event) {
      this.hasEvents = true;
      try {
        const orderData = parseSseJsonEvent(event);
        let mess = "";
        if (0 === "BG".localeCompare(this.getUserLanguage)) {
          mess = "Вашата поръчка №";
        } else {
          mess = "Your order #";
        }
        const stockName = orderData.nBG
          ? orderData.nBG : orderData.nEN;
        const stockNameLabel = stockName && "n/a" !== stockName.toString().toLowerCase()
          ? " (" + stockName + ")" : "";
        mess = mess + orderData.oid + ", " + this.getDate(orderData.ts) +
          ", " + orderData.sc + stockNameLabel + " " +
          orderData.qty + " X " + this.formatPrice(orderData.sp, orderData.cc);
        if (0 === "BG".localeCompare(this.getUserLanguage)) {
          mess = mess + " е отказана";
        } else {
          mess = mess + " is rejected";
        }
        this.$toast.error(mess, {
          "duration": 5000,
          "pauseOnHover": true
        });
        this.$store.commit("addSystemMessage", {
          date: (new Date()).getTime(),
          mess: mess,
          error: true
        });
      } catch (err) {
        console.error(err);
      }
    },
    handleDashboardSseError(event) {
      this.hasEvents = false;
      try {
        if (event.readyState == EventSource.CLOSED) {
          console.log(EventSource);
        }
      } catch (err) {
        console.error(err);
      }
    },
    getDate(unix) {
      return UiUtils.parseUnixTime(unix);
    },
    getOrderType(ot) {
      return 'b' === ot || 'B' === ot ? 
        this.t("buyLabel") :
        this.t("sellLabel");
    }, 
    async getExchangesAndStocks() {
      if (0 !== this.$store.getters["getExchanges"].length) {
        return;
      }      
      const user = this.$store.getters["getUser"];
      // get exchanges and stocks
      try {
        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "get_exchanges_stocks_ex",
            id: user.id,
            key: user.key
          }});
        if (res) {
          // check answer
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);
          if (errorCode === "") {
            // set exchanges
            this.$store.commit("setExchanges", res.data.exchanges);
            // set stocks (unique)
            const itemsToAdd = onlyUnique(res.data.stocks);
            this.$store.commit("setStocks", itemsToAdd); 
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });     
          }
        }
      } catch (e) {
        console.error(e);
      }      
    },
    async getXfraData(xfraList) {
      if (!xfraList || 0 === xfraList.length) {
        return;
      }
      const user = this.$store.getters["getUser"];
      // get exchanges and stocks
      try {
        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "get_stocks_full_xfra",
            id: user.id,
            key: user.key,
            sc: xfraList.join()
          }
        });
        if (res) {
          // check answer
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);
          if (errorCode === "") {
            const xfraExchangeId = this.getXfraExchangeId();
            res.data.stocks.forEach(item => {
              // this answer does not comply with the get_exchanges_stocks_ex answer
              item.code = item.sc;
              item.cMIC = xfraExchangeId;
              item.tID = item.stid;
              this.$store.commit("addStock", item);
            })
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    openWallet() {
      this.$router.push({ name: "Wallet" });
    },
    openDashboard() {
      this.$router.push({ name: "Exchange" });
    },
    openProfile() {
      this.$router.push({ name: "Profile" });
    },
    async getTopTen(what) {
      const user = this.$store.getters["getUser"];
      try {
        // get selected exchange code
        const exchangeCode = UiUtils.getExchangeCodeById(this.getExchanges, this.selectedExchange);
        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "get_top_ten",
            id: user.id,
            key: user.key,
            what: what,
            ex: "" === exchangeCode ? null : exchangeCode
          }
        });
        if (res) {
          // check answer
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);          
          if (errorCode === "") {
            const list = res.data.list || [];
            await this.ensureTopTenStocksData(list);
            switch (what) {
              case "gainers": {
                this.$store.commit("setGainers", list);
                break;
              }
              case "losers": {
                this.$store.commit("setLosers", list);
                break;
              }
              case "most_traded": {
                this.$store.commit("setMostTraded", list);
                break;
              }
            }
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });                 
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async handleTopTenSseEvent(mutation, event) {
      this.hasEvents = true;
      try {
        const payload = parseSseJsonEvent(event);
        await this.ensureTopTenStocksData(payload?.list || [payload]);
        this.$store.commit(mutation, payload);
      } catch (err) {
        console.error(err);
      }
    },
    async ensureTopTenStocksData(items) {
      const missingXfraCodes = this.getMissingXfraStockCodes(items);
      await this.getXfraData(missingXfraCodes);
    },
    getXfraExchangeId() {
      return UiUtils.getExchangeIdByCode(this.getExchanges, "XFRA") || 3;
    },
    getMissingXfraStockCodes(items) {
      const xfraExchangeId = this.getXfraExchangeId();
      const indexedStocks = this.$store.getters["getIndexedStocks"]
        .map(item => item?.toString().toUpperCase());
      const missingCodes = [];

      (items || []).forEach(item => {
        const stockCode = item?.sc?.toString();
        const exchangeCode = item?.ex?.toString();
        if (!stockCode || 0 !== exchangeCode?.toUpperCase().localeCompare("XFRA")) {
          return;
        }

        const stockKey = `${xfraExchangeId}${stockCode}`.toUpperCase();
        if (!indexedStocks.includes(stockKey) && !missingCodes.includes(stockCode)) {
          missingCodes.push(stockCode);
        }
      });

      return missingCodes;
    },
    async getTop10Indexes() {
      const user = this.$store.getters["getUser"];
      try {
        // get selected exchange code
        const exchangeCode = UiUtils.getExchangeCodeById(this.getExchanges, this.selectedExchange);
        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "get_indexes",
            id: user.id,
            key: user.key,
            xc: "" === exchangeCode ? null : exchangeCode
          }
        });
        if (res) {
          // check answer
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);
          if (errorCode === "") {
            this.$store.commit("setIndexes", res.data.list);
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getWallet() {
      const user = this.$store.getters["getUser"];
      try {
        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "get_wallet",
            id: user.id,
            key: user.key,
            d: Math.floor((new Date()).getTime() / 1000)
          }
        });
        if (res) {
          // check answer
          if (ApiUtils.handleTraderNonRecoverableError(res, this.$store, this.$router, this.getUserLanguage)) {
            this.$store.commit("setAppStateReady");
            return;
          }
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);
          if (errorCode === "") {
            this.$store.commit("wallet/setWallet", res.data);
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async subscribeForSse() {
      // get quotes for watchlist
      const stockCodes = [];
      const watchlists = this.$store.getters["getUserWatchlists"];

      if (watchlists) {
        for (let cnt = 0; cnt < watchlists.length; cnt++) {
          stockCodes.push(UiUtils.extractExchangeCodeFromPairObject(watchlists[cnt].sc));
        }
      }
      const user = this.$store.getters["getUser"];
      try {
        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "set_sse",
            id: user.id,
            key: user.key,
            "quote-ex-sts": "off",
            "quote-tr-sts": "on",
            "depth-sts": "off",
            "top10-sts": "on",
            "top10-set": "",
            "top10-typ": "",
            "wallet-sts": "on",
            "phase-sts": "on",
            "quote-sts": "on",
            "quote-set": stockCodes.join()
          }
        });
        if (res) {
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);
          if (errorCode !== "") {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        } 
      } catch (err) {
        console.error(err);
      }
    },
    async getQuoteTr() {
      if ("" === this.selectedItemCode) {
        return;
      }
      // get quote trading for selected item
      const user = this.$store.getters["getUser"];
      // get exchange code
      const exchanges = this.$store.getters["getExchanges"];
      const itemExchangeCode = UiUtils.getExchangeCodeById(exchanges, this.$store.getters["getSelectedTradingExchangeId"]);      
      try {
        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "get_quote_tr",
            id: user.id,
            key: user.key,
            sc: UiUtils.combineExchangeStockPair(itemExchangeCode, this.selectedItemCode)
          }
        });
        if (res) {
          // check answer
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);          
          if (errorCode === "") {
            // set quote tr
            this.quoteTrading = res.data;
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async setQuoteTr(code) {
      if ("" === code) {
        return;
      }
      // set sse for quote tr
      // get exchange code
      const exchanges = this.$store.getters["getExchanges"];
      const itemExchangeCode = UiUtils.getExchangeCodeById(exchanges, this.$store.getters["getSelectedTradingExchangeId"]);
      await ApiUtils.setQuoteTrading(http, UiUtils, this.$store, itemExchangeCode, code);
    },
    checkHasThisStock(stocks, stockCode, exchangeId) {
      const items = stocks.filter(item => {
        return 0 === item.code.toString().toLowerCase().localeCompare(stockCode.toString().toLowerCase() &&
          parseInt(item.cMIC) === parseInt(exchangeId));
      });
      return (items && 0 < items.length);
    },
    userWatchlistNameClick(watchlist) {
      // save the clicked index/watchlist name
      this.$store.commit("setClickedWatchlistName", watchlist.wln.toString());

      this.activeTop10Item = 'INDEX';
      this.activeUserWatchlist = watchlist.wln;
      this.lastActiveUserWatchlist = watchlist.wln;
      this.activeIndexWatchlist = "";
      const stocks = this.$store.getters["getStocks"];
      const exchanges = this.$store.getters["getExchanges"];
      const concerned = UiUtils.extractStocksInWatchlist(stocks, watchlist, exchanges) || [];

      ApiUtils.updateSearchedStocksListUserWatchlist(this.$store, http, UiUtils, concerned, concerned);
    },
    async indexWatchlistNameClick(watchlist) {
      // save the clicked index/watchlist name
      this.$store.commit("setClickedWatchlistName", watchlist.wln.toString());

      this.activeTop10Item = 'INDEX';
      this.activeIndexWatchlist = watchlist.wln;
      this.lastActiveIndexWatchlist = watchlist.wln;
      this.activeUserWatchlist = "";
      const requestId = ++this.indexWatchlistLoadRequestId;
      this.indexWatchlistLoading = true;
      this.$store.commit("setSearchedStocksIndexWatchlist", []);

      try {
        const members = watchlist.sc && 0 < watchlist.sc.length
          ? watchlist.sc
          : await this.getIndexMembers(watchlist.wln, watchlist.xc, watchlist.ord || 0);
        if (requestId !== this.indexWatchlistLoadRequestId) {
          return;
        }

        const stocks = this.$store.getters["getStocks"];
        const exchanges = this.$store.getters["getExchanges"];
        const concerned = UiUtils.extractStocksInWatchlist(stocks, { ...watchlist, sc: members || [] }, exchanges) || [];
        ApiUtils.updateSearchedStocksListIndexWatchlist(this.$store, http, UiUtils, concerned, concerned);
      } finally {
        if (requestId === this.indexWatchlistLoadRequestId) {
          this.indexWatchlistLoading = false;
        }
      }
    },    
    async top10ItemClick(name, loadData = true) {
      if (0 === name.localeCompare('INDEX')) {
        this.activeTop10Item = name;
        if (this.lastActiveUserWatchlist) {
          this.activeUserWatchlist = this.lastActiveUserWatchlist;
        }
        return;
      }

      if (0 === this.activeTop10Item.localeCompare('INDEX')) {
        this.lastActiveUserWatchlist = this.activeUserWatchlist;
      }
      this.activeUserWatchlist = "";
      this.activeTop10Item = name;

      if (!loadData) {
        return;
      }

      await this.loadTopTenDataWithPreloader(name);
    },
    isTopTenSelection(name) {
      return ['GAINERS', 'LOSERS', 'MOST TRADED', 'INDEXES'].includes(name);
    },
    async loadTopTenDataForSelection(name) {
      switch (name) {
        case 'GAINERS': {
          await this.getTopTen('gainers');
          break;
        }
        case 'LOSERS': {
          await this.getTopTen('losers');
          break;
        }
        case 'MOST TRADED': {
          await this.getTopTen('most_traded');
          break;
        }
        case 'INDEXES': {
          await this.getTop10Indexes();
          break;
        }
      }
    },
    async loadTopTenDataWithPreloader(name) {
      const requestId = ++this.topTenLoadRequestId;
      this.topTenLoading = true;
      try {
        await this.loadTopTenDataForSelection(name);
      } finally {
        if (requestId === this.topTenLoadRequestId) {
          this.topTenLoading = false;
        }
      }
    },
    setWatchlistToDelete(name) {
      this.watchlistNameToDelete = name;
      this.watchlistSelectionModalActive = true;
      this.watchlistSelectionModalShow = true;      
    },
    async deleteWatchlist() {
      const user = this.$store.getters["getUser"];
      if ("" === this.watchlistNameToDelete) {
        return;
      }
      // delete watchlist
      try {
        let res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "delete_watchlist",
            id: user.id,
            key: user.key,
            wln: this.watchlistNameToDelete
          }
        });
        if (res) {
          // check answer
          if (ApiUtils.isApiResponseInvalidSession(res)) {
            this.$store.commit("setAppStateReady");
            // logout
            setTimeout(
              ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
              500);
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);          
          if (errorCode === "") {
            // update user watchlists
            res = await http.getApiClient(this.getUserType()).get("", {
              params: {
                a: "get_watchlist",
                id: user.id,
                key: user.key
              }
            });
            if (0 === res.data.ec) {
              this.$store.commit("updateWatchlists", res.data.wls);
              this.watchlistNameToDelete = "";
              // select new watchlist if any
              if (0 !== res.data.wls.length) {
                this.userWatchlistNameClick(res.data.wls[0]);
              } else {
                // remove all stocks from list
                this.$store.commit("setSearchedStocksUserWatchlist", []);
              }
            }
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("addSystemMessage", {
              date: (new Date()).getTime(),
              mess: errorCode,
              error: true
            });
          }
        }
      } catch (e) {
        console.error(e);
      }

      this.watchlistSelectionModalActive = false;
      this.watchlistSelectionModalShow = false;
    },
    async getIndexMembers(index, exchangeCode, sortPosition) {
      const user = this.$store.getters["getUser"];
      const resolvedExchangeCode = exchangeCode ||
        DEFAULT_INDEX_WATCHLISTS.find(watchlist => 0 === watchlist.wln.toString().toUpperCase().localeCompare(index.toString().toUpperCase()))?.xc;
      if (!resolvedExchangeCode) {
        return [];
      }
      try {
        const res = await http.getApiClient(this.getUserType()).get("", {
            params: {
              a: "get_indexes_members",
              id: user.id,
              key: user.key,
              idx: index
            }
          });
          if (res) {
            // check answer
            if (ApiUtils.isApiResponseInvalidSession(res)) {
              this.$store.commit("setAppStateReady");
              // logout
              setTimeout(
                ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
                500);
              return;
            }
            if (0 === res.data.ec) {
              const members = [];
              const responseMembers = res.data.list?.[0]?.members || [];
              responseMembers.forEach(item => {
                members.push(UiUtils.createExchangeStockCodePairObject(resolvedExchangeCode, item));
              });
              this.$store.commit("addIndexesWatchlists", {
                index: sortPosition,
                arr: {
                  wln: index,
                  xc: resolvedExchangeCode,
                  sc: members
                }
              });
              return members;
            }
          }
        } catch (e) {
          console.error(e);
        }
      return [];
    },
    buildIndexedWatchlistsFromExchanges() {
      if (0 !== this.$store.getters["getIndexesWatchlists"].length) {
        return;
      }
      const exchanges = [...(this.$store.getters["getExchanges"] || [])];
      const indexesWatchlists = [];
      if (exchanges && 0 < exchanges?.length) {
        exchanges.sort((a, b) => a.eID - b.eID);
        const seenIndexes = new Set();
        for (let cnt = 0; cnt < exchanges.length; cnt++) {
          const exchange = exchanges[cnt];
          for (let indexCnt = 0; indexCnt < (exchange.indexes || []).length; indexCnt++) {
            const indexName = exchange.indexes[indexCnt].n?.toString();
            const indexKey = indexName?.toUpperCase();
            if (!indexKey || seenIndexes.has(indexKey)) {
              continue;
            }
            seenIndexes.add(indexKey);
            indexesWatchlists.push({
              wln: indexName,
              xc: exchange.code,
              sc: [],
              ord: indexesWatchlists.length
            });
          }
        }
      }
      this.$store.commit("setIndexesWatchlists", indexesWatchlists);
    },
    canDeleteWatchlist(name) {
      if (0 === 'default'.localeCompare(name.toString().toLowerCase())) {
        return false;
      }
      // index names
      const indexes = this.$store.getters["getIndexesWatchlists"];
      if (indexes && 0 < indexes?.length) {
        for (let cnt = 0; cnt < indexes.length; cnt ++) {
          const wl = indexes[cnt];
          if (0 === wl.wln.toString().toLowerCase().localeCompare(name.toString().toLowerCase())) {
            return false;
          }          
        }
      }

      return true;
    },
    getStockName(stockCode, exchangeCode) {
      const stocks = this.$store.getters["getStocks"];
      const indexedStocks = this.$store.getters["getIndexedStocks"];
      const exchanges = this.$store.getters["getExchanges"];
      const exchangeId = UiUtils.getExchangeIdByCode(exchanges, exchangeCode);
      return UiUtils.getStockName(stocks, indexedStocks, stockCode, exchangeId, this.getUserLanguage);
    },
  },
  computed: {
    getWindowsWidth() {
      return this.$store.getters["getAppWindowWidth"] || window.innerWidth;
    },    
    getUserLanguage() {
      return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
    },
    getUserWatchLists() {
      const user = this.$store.getters["getUser"];
      return UiUtils.getUserWatchlists(user);
    },
    getIndexedWatchlists() {
      const selectedExchange = parseInt(this.getSelectedExchangeCode);
      if (!selectedExchange) {
        return DEFAULT_INDEX_WATCHLISTS;
      }
      return DEFAULT_INDEX_WATCHLISTS.filter(watchlist => watchlist.exchangeIds.includes(selectedExchange));
    },
    getSelectedExchangeCode() {
      return this.$store.getters["getSelectedExchangeCode"];
    },
    getGainers() {
      const gainers = this.$store.getters["getGainers"].slice();
      switch (this.activeSortingOption) {
        case 0: return gainers;
        case 1: {
          // symbol asc
          return gainers.sort(dynamicSort('sc'));
        }
        case 2: {
          // symbol desc
          return gainers.sort(dynamicSort('-sc'));
        }
        case 3: {
          // name asc
          // add names
          gainers.forEach(item => {
            item.name = this.getStockName(item.sc, item.ex);
          })
          return gainers.sort(dynamicSort('name'));
        }
        case 4: {
          // name desc
          // add names
          gainers.forEach(item => {
            item.name = this.getStockName(item.sc, item.ex);
          })
          return gainers.sort(dynamicSort('-name'));
        }
      }      
      return this.$store.getters["getGainers"];
    },
    getLosers() {
      const losers = this.$store.getters["getLosers"].slice();
      switch (this.activeSortingOption) {
        case 0: return losers;
        case 1: {
          // symbol asc
          return losers.sort(dynamicSort('sc'));
        }
        case 2: {
          // symbol desc
          return losers.sort(dynamicSort('-sc'));
        }
        case 3: {          
          // name asc
          // add names
          losers.forEach(item => {
            item.name = this.getStockName(item.sc, item.ex);
          })
          return losers.sort(dynamicSort('name'));
        }
        case 4: {
          // name desc
          // add names
          losers.forEach(item => {
            item.name = this.getStockName(item.sc, item.ex);
          })
          return losers.sort(dynamicSort('-name'));
        }
      }       
      return this.$store.getters["getLosers"];
    },
    getMostTraded() {
      const mostTraded = this.$store.getters["getMostTraded"].slice();
      switch (this.activeSortingOption) {
        case 0: return mostTraded;
        case 1: {
          // symbol asc
          return mostTraded.sort(dynamicSort('sc'));
        }
        case 2: {
          // symbol desc
          return mostTraded.sort(dynamicSort('-sc'));
        }
        case 3: {
          // name asc
          // add names
          mostTraded.forEach(item => {
            item.name = this.getStockName(item.sc, item.ex);
          })
          return mostTraded.sort(dynamicSort('name'));
        }
        case 4: {
          // name desc
          // add names
          mostTraded.forEach(item => {
            item.name = this.getStockName(item.sc, item.ex);
          })
          return mostTraded.sort(dynamicSort('-name'));
        }
      }         
      return this.$store.getters["getMostTraded"];
    },
    getIndexes() {
      const indexes = this.$store.getters["getIndexes"].slice();
      switch (this.activeSortingOption) {
        case 0: return indexes;
        case 1, 3: {
          // symbol asc
          return indexes.sort(dynamicSort('sc'));
        }
        case 2, 4: {
          // symbol desc
          return indexes.sort(dynamicSort('-sc'));
        }
      }
      return this.$store.getters["getIndexes"];
    },
    getSelectedTradingCode() {
      return this.$store.getters["getSelectedTradingCode"];
    },
    getExchanges() {
      return this.$store.getters["getExchanges"];
    },
    getSearchPlaceholder() {
      return this.t("dashboardLabel");
    },
    getStockLabel() {
      return this.t("stockLabel");
    },
    getBuyLabel() {
      return this.t("buyLabel");
    },
    getSellLabel() {
      return this.t("sellLabel");
    },
    getLastDealLabel() {
      return this.t("lastDealLabel");
    },
    getTurnoverLabel() {
      return this.t("turnoverLabel");
    },
    getIndexMembersLabel() {
      return this.t("indexMembersLabel");
    },    
    getGainersLabel() {
      return this.t("gainersLabel");
    },
    getLosersLabel() {
      return this.t("losersLabel");
    },
    getMostTradedLabel() {
      return this.t("mostTradedLabel");
    },
    getIndexesLabel() {
      return this.t("indexesLabel");
    },
    topTenSelections() {
      return [
        { value: "GAINERS", label: this.getGainersLabel },
        { value: "LOSERS", label: this.getLosersLabel },
        { value: "MOST TRADED", label: this.getMostTradedLabel },
        { value: "INDEXES", label: this.getIndexesLabel }
      ];
    },
    getIndexLabel() {
      return this.t("indexLabel");
    },
    getChangeLabel() {
      return this.t("changeLabel");
    },
    getNetChangeLabel() {
      return this.t("netChangeLabel");
    },
    getValueLabel() {
      return this.t("valueLabel");
    },
    getConfirmDeleteValueLabel() {
      return this.t("deleteWatchlistLabel");
    },
    getCloseLabel() {
      return this.t("closeLabel");
    },
    getConfirmLabel() {
      return this.t("confirmLabel");
    },
    getCouldNotSetExchangesMessage() {
      return this.t("couldNotSetExchangesMessage");
    },
    getCouldNotReadMessage() {
      return this.t("couldNotReadMessage");
    },
    getCouldNotReadIndexesMessage() {
      return this.t("couldNotReadIndexesMessage");
    },
    getCouldNotReadWalletMessage() {
      return this.t("couldNotReadWalletMessage");
    },
    getCouldNotReadQuotesMessage() {
      return this.t("couldNotReadQuotesMessage");
    },
    getCouldNotSetSseMessage() {
      return this.t("couldNotSetSseMessage");
    },
    getCouldNotDeleteWatchlistMessage() {
      return this.t("couldNotDeleteWatchlistMessage");
    },
    getAllExchangesLabel() {
      return this.t("allExchangesLabel");
    },
    getReestablishingConnectionLabel() {
      return this.t("reestablishingConnectionLabel");
    },
    getReestablishedConnectionLabel() {
      return this.t("reestablishedConnectionLabel");
    }, 
    getSearchedStocks() {
      return this.$store.getters["getSearchedStocksUserWatchlist"];
    },
    getWatchlistLabel() {
      return this.t("watchlistLabel");
    },
    getSortSymbolAscLabel() {
      return this.t("sortSymbolAscLabel");
    },
    getSortSymbolDescLabel() {
      return this.t("sortSymbolDescLabel");
    },
    getSortNameAscLabel() {
      return this.t("sortNameAscLabel");
    },
    getSortNameDescLabel() {
      return this.t("sortNameDescLabel");
    },
    getSortDefaultLabel() {
      return this.t("sortDefaultLabel");
    },
    getInvalidSessionLabel() {
      return this.t("invalidSessionLabel");
    },
    stopSseState() {
      return this.$store.getters["getStopSse"];
    }    
  },
  async mounted() {
    this.$store.commit("setAppStateNotReady");
    // get wallet, exchanges and quotes
    await this.getExchangesAndStocks();
    this.buildIndexedWatchlistsFromExchanges();
    // open default watchlist when loaded first time
    // set selected watchlist if none
    const userWatchlists = this.getUserWatchLists;
    if (userWatchlists && 0 < userWatchlists.length) {
      // we will download only data for watchlists if any on load
      // get XFRA data for watchlists
      const xfraList = [];
      userWatchlists.forEach(element => {
        element.sc?.forEach(stock => {
          if (0 === stock?.xc.toString().toUpperCase().localeCompare('XFRA')) {
            xfraList.push(stock.sc);
          }
        });
      });
      await this.getXfraData(xfraList);
      this.userWatchlistNameClick(userWatchlists[0]);
    } 
    await Promise.all([this.getWallet(), this.subscribeForSse()]);
    this.$store.commit("setAppStateReady");

    // start sse
    this.hasEvents = false;    
    this.setupStream();
    // start sse monitor
    this.sseVerifier = startSseMonitor({
      getClient: () => this.sseClient,
      setClient: (client) => { this.sseClient = client; },
      hasEvents: () => this.hasEvents,
      setupStream: () => this.setupStream()
    });      
  },
  unmounted() {
    // stop verifier
    stopSseMonitor(this.sseVerifier);
    // close sse
    closeSseClient(this.sseClient);
  }
};
</script>

<style scoped>

  @media (min-width: 1200px) {
    #watchlists-column {
      min-height: calc(100vh - 8rem);
    }
  }

  tbody {
    overflow-y: auto;
    overflow-x: hidden;
  }

  th {
    width: 100%;
  }

  .name-column {
    vertical-align: middle;
    text-align: center;  
  }
  .data-column {
    vertical-align: middle;
    text-align: center;
  }

  .indexes-table {
    table-layout: fixed;
  }

  .indexes-watchlist-table {
    height: calc(100vh - 7.1rem);
    overflow-y: auto;
  }

  .indexes-table th {
    white-space: nowrap;
  }

  .indexes-table .index-column-width {
    width: 46%;
  }

  .indexes-table .index-data-column-width {
    width: 18%;
  }

  .top-ten-loading {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 20rem;
    width: 100%;
  }

  .top-ten-loading.index-watchlist-loading {
    min-height: 41rem;
  }

  .top-ten-loading :deep(.hollow-dots-spinner) {
    transform: scale(2);
    transform-origin: center;
  }
  
  .large-data-column {
    min-width: 9rem;
    vertical-align: middle;
    text-align: center;
    padding-right: 2rem;    
  }
  .watchlists-list {
    max-height: 41rem;
  }

  .watchlist-tabs {
    margin-top: 2px;
  }

  .watchlist-sort-menu .dropdown-item {
    font-size: 1rem;
  }

  .watchlist-selection-menu .dropdown-item {
    font-size: 1rem;
  }

  .indexes-table td {
    cursor: default;
    font-size: 1rem;
  }

  .trade-confirmed-modal-header {
    border-bottom: 0;
    justify-content: flex-end;
    padding-bottom: 0;
  }

  #top10-column #watchlists-column #trading-column {
    min-height: 30rem;
    max-height: 30rem;
  }

    .stock-data {
        vertical-align: middle;
        text-align: end;
        display: table-cell;
        cursor: pointer;
    }

    .stock-name {
        vertical-align: middle;
        text-align: start;
    }

    .greenColor {
        color: #189e18;
    }

    .redColor {
        color: #ff0000;
    }

    .whiteColor {
        color: #ffffff;
    }

    .blackColor {
        color: #000000;
    }

    .greenBackgroundColor {
        background: #74b21f;
        border: 1px solid #74b21f;
        border-radius: 8px;
    }

    .redBackgroundColor {
        background: #ff0000;
        border: 1px solid #ff0000;
        border-radius: 8px;
    }

    .whiteBackgroundColor {
        background: #ffffff;
        border: 1px solid black;
        border-radius: 8px;
    }
.xxsmall-font-size {
    font-size: xx-small;
}

.xsmall-font-size {
    font-size: x-small;
}
</style>
